module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }